import '.l{display:flex;}.ssr-plugin'
import '.b2{align-items:stretch;}.ssr-plugin'
import '.jn{align-self:stretch;}.ssr-plugin'
import '.n{gap:0.5rem;}.ssr-plugin'
import '.as{position:fixed;}.ssr-plugin'
import '.cz{top:0;}.ssr-plugin'
import '.c5{left:0px;}.ssr-plugin'
import '.c6{right:0px;}.ssr-plugin'
import '.fi{bottom:0px;}.ssr-plugin'
import '.fj{z-index:9999;}.ssr-plugin'
import '.b5{background-color:var(--palette-white);}.ssr-plugin'
import '.fk{transition:transform 0.3s ease-in-out;}.ssr-plugin'
import '.m{flex-direction:column;}.ssr-plugin'
import '.ch{flex:1;}.ssr-plugin'
import '.ba{overflow-y:auto;}.ssr-plugin'
import '.d6{min-height:0px;}.ssr-plugin'
import { useEffect, useState } from 'react'
import Column from '@app/components/layout/Column'
import { Button } from '@app/components/core/button/Button'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { useTranslations } from '@i18n/useLanguage'
import { MainMenu } from './menusMobile/MainMenu'
import { MobileMenuPage } from './blocks/common'
import { FindMenu } from './menusMobile/FindMenu'
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons'
import { StartMenu } from './menusMobile/StartMenu'
import { LearnMenu } from './menusMobile/LearnMenu'
import { AboutUsMenu } from './menusMobile/AboutUsMenu'
import { styled } from 'inlines'
import { useAuthModal } from '@app/util/hooks/useAuthModal'

export type MegaMenuProps = {
  onClose: () => void
  isAuthenticated: boolean
  isOpen: boolean
}

export const MegaMenu = ({
  onClose,
  isAuthenticated,
  isOpen,
}: MegaMenuProps) => {
  const translations = useTranslations().app.nav
  const [page, setPage] = useState<MobileMenuPage>(MobileMenuPage.main)
  const onBack =
    page === MobileMenuPage.main
      ? undefined
      : () => setPage(MobileMenuPage.main)
  const { showAuthModal } = useAuthModal()

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = ''
    }
    return () => {
      document.body.style.overflow = ''
    }
  }, [isOpen])

  const authButtons = isAuthenticated ? null : (
    <div className="l b2 jn n"
    >
      <Button
        label={translations.logIn}
        variant="secondary"
        style={{ flex: '1 0 0' }}
        onClick={() => {
          showAuthModal('login')
        }}
      />
      <Button
        style={{ flex: '1 0 0' }}
        onClick={() => {
          showAuthModal('signUp')
        }}
        label={translations.signUp}
      />
    </div>
  )

  return (
    <div className="as cz c5 c6 fi fj b5 fk l m"
      style={{
        transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',}}
    >
      <Column
        style={{
          display: 'flex',
          height: '100%',
          padding: '1rem 1.5rem',
          gap: '1.5rem',
          background: 'var(--palette-white)',
        }}
      >
        <TopSection onClose={onClose} onBack={onBack} />
        <div className="ch ba d6">
          <MainSection page={page} setPage={setPage} onClose={onClose} />
        </div>
        {authButtons}
      </Column>
    </div>
  )
}

type MainSectionProps = {
  page: MobileMenuPage
  setPage: (page: MobileMenuPage) => void
  onClose: () => void
}

const MainSection = ({ page, setPage, onClose }: MainSectionProps) => {
  switch (page) {
    case MobileMenuPage.main:
      return <MainMenu setPage={setPage} />
    case MobileMenuPage.find:
      return <FindMenu onClose={onClose} />
    case MobileMenuPage.start:
      return <StartMenu />
    case MobileMenuPage.learn:
      return <LearnMenu />
    case MobileMenuPage.aboutUs:
      return <AboutUsMenu />
  }
}

const TopSection = ({
  onClose,
  onBack,
}: {
  onClose: () => void
  onBack?: () => void
}) => {
  const translations = useTranslations().app.common
  const backButton = onBack ? (
    <Button
      onClick={onBack}
      icon={faArrowLeft}
      iconPosition="left"
      variant="link"
      label={translations.back}
    />
  ) : null
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row-reverse',
        alignItems: 'center',
        alignSelf: 'stretch',
        justifyContent: 'space-between',
      }}
    >
      <CloseButton onClick={onClose} />
      {backButton}
    </div>
  )
}
